import { render, staticRenderFns } from "./ReceivingAddress.vue?vue&type=template&id=f20ee0c8&scoped=true"
import script from "./ReceivingAddress.vue?vue&type=script&lang=js"
export * from "./ReceivingAddress.vue?vue&type=script&lang=js"
import style0 from "./ReceivingAddress.vue?vue&type=style&index=0&id=f20ee0c8&prod&lang=scss&scoped=true"
import style1 from "./ReceivingAddress.vue?vue&type=style&index=1&id=f20ee0c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20ee0c8",
  null
  
)

export default component.exports